<template>
    <div class="Home container">
        <Btn></Btn>
        <Card>
            <div class="cardWrapper mt-2">
                <div @click="$router.go(-1)" class="kembali backBtn text-blue mb-3"><i class="fas fa-chevron-left"></i>
                    Kembali</div>
                <form @submit.prevent="forgotPass">
                    <label for="nohp">Nomor Handphone</label>
                    <div class="btn-group-icon blue">
                    <input name="nohp" oninvalid="this.setCustomValidity('Nomor handphone wajib diisi')" oninput="this.setCustomValidity('')" class="input-outline" @keypress="($event) => numericOnly($event)" type="number" v-model="form.number" required>
                    <div class="underline"></div>
                    </div>
                    <label for="pass">Kata Sandi Baru</label>
                    <div class="btn-group-icon blue">
                    <input name="pass" placeholder="Minimal 6 karakter gabungan huruf dan angka" class="input-outline" :type="`${showPass ? 'text' : 'password'}`" v-model="form.password" required oninvalid="this.setCustomValidity('Kata sandi wajib diisi')" oninput="this.setCustomValidity('')">
                    <i :class="`far ${showPass? 'fa-eye-slash' : 'fa-eye'}`" @click="showPass ? showPass = false : showPass = true"></i>
                    <div class="underline"></div>
                    </div>
                    <label for="repassword">Ulangi Kata Sandi Baru</label>
                    <div class="btn-group-icon blue">
                    <input name="repassword" class="input-outline" :type="`${showRePass ? 'text' : 'password'}`" v-model="form.repassword" required oninvalid="this.setCustomValidity('Ulangi kata sandi wajib diisi')" oninput="this.setCustomValidity('')">
                     <i :class="`far ${showRePass? 'fa-eye-slash' : 'fa-eye'}`" @click="showRePass ? showRePass = false : showRePass = true"></i>
                    <div class="underline"></div>
                    </div>
                    <button class="btn-fill red rounded mt-2">Reset Ulang Kata Sandi</button>
                </form>
                <button @click="$router.go(-1)" class="btnBackBottom btn-outline red rounded">Kembali</button>
            </div>
        </Card>
        <Loader v-if="isLoad" />
    </div>
</template>

<script>
import Card from '../components/cardCenter.vue'
import Btn from '../components/backBtn.vue'
import Loader from '../components/loader.vue'
import validation from '../mixins/validation'
import axios from 'axios'
export default {
  components: {
    Card,
    Btn,
    Loader
  },
  mixins: [validation],
  data () {
    return {
      isLoad: false,
      form: {
        number: '',
        password: '',
        repassword: ''
      },
      showPass: false,
      showRePass: false
    }
  },
  // watch: {
  //     'form.password': {
  //         handler(password) {
  //             this.logger(password, 'password')
  //             this.updateCustomValidity();
  //         }
  //     }
  // },
  methods: {
    async forgotPass () {
      const regex = /(?=.*\d)(?=.*[a-zA-Z]).{6,}/
      if (!regex.test(this.form.password)) {
        this.toast({ type: 'warning', message: 'Kata sandi minimal 6 karakter mengandung huruf dan angka' })
        return
      }
      if (this.form.password !== this.form.repassword) {
        this.toast({ type: 'warning', message: 'Kata sandi harus sama' })
        return
      }
      try {
        this.isLoad = true
        const res = await axios.get(`auth/forgotpassword?number=${this.form.number}`)
        this.$cookie.setCookie('password', this.form.password, { expire: '1D' })
        localStorage.setItem('valid', res.data.expired_datetime)
        this.$cookie.setCookie('activityID', res.data?.user_activity_id, { expire: '1D' })
        this.isLoad = false
        this.$router.push({
          name: 'Verifikasi',
          params: {
            number: this.form.number,
            type: 'forgotPassword'
          }
        })
      } catch (err) {
        this.logger(err)
        this.isLoad = false
        if (err?.response?.data?.message.includes('Mohon menunggu')) {
          this.$router.push({ name: 'Verifikasi', params: { number: this.form.number, type: 'forgotPassword' } })
        } else if (err.response && err.response.data === 'Bad mobile number format') {
          // this.err.number = 'Nomor hp tidak valid'
          this.alertFailed('Nomor hp tidak valid')
        } else {
          this.toast({ type: err.response?.data?.status, message: err.response?.data?.message })
        }
      }
    }
    // updateCustomValidity(){
    //     var el = this.$refs.passwordInput;
    //     this.logger('awww')
    //     el.oninvalid = el.setCustomValidity('Kata sandi minimal 8 karakter dan harus mengandung hruruf besar, huruf kecil dan angka');
    // },
  }
}
</script>

<style lang="scss" scoped>
    @import '../assets/scss/Layout/home.scss';
</style>
